"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = void 0;
var useModal_1 = require("./useModal");
Object.defineProperty(exports, "useModal", { enumerable: true, get: function () { return __importDefault(useModal_1).default; } });
